import { EntityType } from "@/services/hooks/entities/useEntityType";

export interface AnchoredFieldConfig {
  fieldKey: string;
  anchorFieldKey: string;
}

export const ANCHORED_FIELDS_CONFIG: Partial<
  Record<EntityType, AnchoredFieldConfig[]>
> = {
  [EntityType.LEAD]: [
    { fieldKey: "inboundCampaignType", anchorFieldKey: "source" },
    { fieldKey: "outboundCampaignType", anchorFieldKey: "source" }
  ]
};

export const getAnchoredFieldKeys = (entityType: EntityType): string[] => {
  const config = ANCHORED_FIELDS_CONFIG[entityType];
  if (!config) return [];
  return config.map((c) => c.fieldKey);
};

export const getFieldsAnchoredTo = (
  entityType: EntityType,
  anchorFieldKey: string
): string[] => {
  const config = ANCHORED_FIELDS_CONFIG[entityType];
  if (!config) return [];
  return config
    .filter((c) => c.anchorFieldKey === anchorFieldKey)
    .map((c) => c.fieldKey);
};
